import { useMemo } from 'react'

import { useScreen } from '@/store/screen'

export const useAuthor = () => {
  const { windowSize } = useScreen()

  const fontSizesByScreenSize = useMemo(() => {
    const fontSizesByScreen = {
      1440: {
        title: 'h5' as const,
        author: 'h4' as const,
        office: 'b1' as const,
      },
      791: {
        title: 'b3' as const,
        author: 'b2' as const,
        office: 'b4' as const,
      },
    }

    return fontSizesByScreen
  }, [])

  const responsiveSizes = {
    1440: {
      height: 200,
      width: 200,
    },
    791: {
      height: 120,
      width: 120,
    },
    480: {
      height: 100,
      width: 100,
    },
  }

  const { width } = windowSize
  const fontSizes = useMemo(() => {
    if (!width) return fontSizesByScreenSize[1440]
    if (width <= 791) return fontSizesByScreenSize[791]
    return fontSizesByScreenSize[1440]
  }, [width, fontSizesByScreenSize])

  return {
    fontSizes,
    responsiveSizes,
  }
}
